import { type CaptureFlags } from '../ports/flags';
import { getConfiguredFlags } from './configuration';

// The seam the engine reads flags through. Every getter resolves the configured
// bag per call, never cached at configure time, so a mid-session flip is seen by
// the next read. Ledger eligibility is once-per-page and lives elsewhere.
export const captureFlags: CaptureFlags = {
  isDefaultTelehealthModeEnabled: () =>
    getConfiguredFlags().isDefaultTelehealthModeEnabled(),
  isTelehealthAllowCurrentTabEnabled: () =>
    getConfiguredFlags().isTelehealthAllowCurrentTabEnabled(),
  useTranscriptionServiceV2: () => getConfiguredFlags().useTranscriptionServiceV2(),
  isMediaRecorderTimesliceEnabled: () =>
    getConfiguredFlags().isMediaRecorderTimesliceEnabled(),
};
